import { Component, OnInit, input, signal } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { CardComponent } from '../../../../../shared/components/card/card.component';
import { DatePipe } from '@angular/common';
import { ImageModule } from 'primeng/image';
import { Location } from '../../../../../shared/models/location.model';
import { LocationModalComponent } from '../../../../../components/modals/location-modal/location-modal.component';
import { LocationService } from '../../../../../services/location/location.service';
import { MessageService } from 'primeng/api';
import { Pagination } from '../../../../../shared/models/pagination.model';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-user-pet-location',
  imports: [
    LocationModalComponent,
    ButtonModule,
    CardComponent,
    DatePipe,
    ImageModule
  ],
  templateUrl: './user-pet-location.component.html',
  styleUrl: './user-pet-location.component.scss'
})
export class UserPetLocationComponent implements OnInit {
  readonly userId = input.required<string>();

  readonly isModalOpen = signal<boolean>(false);

  readonly isCardLoading = signal<boolean>(true);
  readonly selectedLocation = signal<Location | null>(null);
  readonly locations = signal<Location[]>([]);

  readonly nextPage = signal<number>(0);
  readonly totalLocations = signal<number>(0);
  readonly isDeleteMode = signal<boolean>(false);

  constructor(private readonly locationService: LocationService,
    private readonly messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.fetchLocations(0, true);
  }

  onModalOpen(isDeleteMode: boolean, idx: number, event: MouseEvent | null = null): void {
    if (event) {
      event.stopPropagation();
    }
    this.selectedLocation.set(this.locations()[idx]);
    this.isDeleteMode.set(isDeleteMode);
    this.isModalOpen.set(true);
  }

  fetchLocations(page: number, resetList: boolean = false): void {
    this.isCardLoading.set(true);
    this.locationService.paginateRecentLocationByUserId(this.userId(), page)
      .pipe(finalize(() => this.isCardLoading.set(false)))
      .subscribe({
        next: (locationPage: Pagination<Location>) => {
          if (resetList) {
            this.locations.set(locationPage.rows);
            this.nextPage.set(1);
          } else {
            this.locations.update(prev => [...prev, ...locationPage.rows]);
            this.nextPage.update(prev => prev + 1);
          }

          this.totalLocations.set(locationPage.count);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha ao recuperar histórico de localização',
            life: 4000
          });
        }
      });
  }
}
